import { put, select, takeEvery, call } from 'redux-saga/effects';
import { selectAuth } from 'store/auth/selector';

import {
  loadOrderTimeRequested,
  loadOrderTimeSuccess,
  loadOrderTimeFail,
  storeOrderRequested,
  storeOrderSuccess,
  storeOrderFail,
  loadOrdersRequested,
  loadOrdersSuccess,
  loadOrdersFail,
  loadOrderRequested,
  loadOrderFail,
  loadOrderSuccess,
  updateOrderStatusRequested,
  updateOrderStatusSuccess,
  updateOrderStatusFail,
  updateOrderTypeRequested,
  updateOrderTypeSuccess,
  updateOrderTypeFail,
} from './orderSlice';
import { apiURL, axiosInstance } from 'config';
import toast from 'react-hot-toast';
import { ORDER_SUCCESS } from 'constants/routes';
import { updateUserEffect } from 'store/user/sagas';

export function* loadOrderTimeEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(axiosInstance.get, `${apiURL}/get-time-slots`);
    if (data?.succeeded) {
      yield put(loadOrderTimeSuccess(data));
    }
  } catch (error: any) {
    yield put(loadOrderTimeFail(error.message));
  }
}

export function* storeOrderEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  const auth = yield select(selectAuth);
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/create-order`,
      action.payload?.values
    );
    yield put(storeOrderSuccess(data));

    if (data?.succeeded) {

      yield call(updateUserEffect, {
        payload: {
          id: auth?.auth?.user?.id,
          email: auth?.auth?.user?.username,
          firstname: auth?.auth?.user?.firstname,
          lastname: auth?.auth?.user?.lastname,
          mobile: action.payload?.values?.orderRequest?.changedMobileData,
        },
        type: '',
      });

      if (data?.result?.url === null) {
        toast.success('Your order placed successfully.');
        action.payload?.navigate(
          ORDER_SUCCESS?.replace(
            ':id',
            data?.result?.orderReferenceNo?.slice(1)
          )
        );
      } else {
        window.location.href = data?.result?.url;
      }
    } else {
      toast.error(
        'Your order could not be processed at this time! Please try again later.'
      );
    }
  } catch (error: any) {
    yield put(storeOrderFail(error.message));
    toast.error(
      'Your order could not be processed at this time! Please try again later.'
    );
  }
}

export function* loadOrdersEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-order-by-userid?userId=${action?.payload?.userId}`
    );
    if (data?.succeeded) {
      yield put(loadOrdersSuccess(data));
    }
  } catch (error: any) {
    yield put(loadOrdersFail(error.message));
  }
}

export function* loadOrderEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/get-order-by-refno?rNo=%23${action?.payload?.id}`
    );
    yield put(loadOrderSuccess(data));
  } catch (error: any) {
    yield put(loadOrderFail(error.message));
  }
}

export function* updateOrderStatusEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/order-status-change-with-payment`,
      action.payload
    );
    yield put(updateOrderStatusSuccess(data));
  } catch (error: any) {
    yield put(updateOrderStatusFail(error.message));
  }
}

export function* updateOrderTypeEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const data = action.payload;
    yield put(updateOrderTypeSuccess(data));
  } catch (error: any) {
    yield put(updateOrderTypeFail(error.message));
  }
}

export function* orderSaga(): Generator<any, void, any> {
  yield takeEvery(loadOrderTimeRequested, loadOrderTimeEffect);
  yield takeEvery(storeOrderRequested, storeOrderEffect);
  yield takeEvery(loadOrdersRequested, loadOrdersEffect);
  yield takeEvery(loadOrderRequested, loadOrderEffect);
  yield takeEvery(updateOrderStatusRequested, updateOrderStatusEffect);
  yield takeEvery(updateOrderTypeRequested, updateOrderTypeEffect);
}
